import React from 'react';

interface ProductSearchProps {
  inputId: string;
  labelValue: string;
  inputValue: string;
  onInputChange: (value: string) => void;
}

export default function ProductSearchInputField(props: ProductSearchProps) {
  return (
    <div className="col-12 col-sm-4 form-group">
      <label className="modal-label form-label" htmlFor={props.inputId}>
        {props.labelValue}
      </label>
      <input
        id={props.inputId}
        name={props.inputId}
        value={props.inputValue}
        className="form-control"
        onChange={(u) => props.onInputChange(u.target.value)}
      />
    </div>
  );
}
